//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ContactPage',
  data: () => ({
    heading: 'Contact',
    description: 'Want to get in touch? Check out my details below.',
  }),
  head() {
    return {
      htmlAttrs: {
        itemtype: 'https://schema.org/ContactPage',
      },
      title: this.heading,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.description,
        },
      ],
    };
  },
};
